import { ApiService } from "@/api";

export const bindUserGroupToSampleGroup = (
  userGroupId: string,
  sampleGroupId: string
) => {
  return ApiService.baseAction(
    "sample-group/bind_group",
    {
      data: {
        userGroupId,
        sampleGroupId,
      },
    },
    "post"
  );
};
